import React from 'react';
import Collapse, { CollapseCropColor } from '@lib/components/Collapse/Collapse';
import { BaseItem, CellProps } from '@lib/components/Table/types';

interface Props {
  minHeight: number;
  cropColor?: CollapseCropColor;
}

function CollapseCell<T extends BaseItem>({
  value,
  minHeight,
  cropColor,
}: CellProps<T> & Props) {
  return (
    <Collapse minHeight={minHeight} cropColor={cropColor}>
      {value}
    </Collapse>
  );
}

export default CollapseCell;
